import React from "react";
import { NavLink } from "react-router-dom";
import ReactPlayer from "react-player";

var bgimg1 =
  "https://theme7x.com/react/inteshape/static/media/6.ab9e0b39f4b67e7c7763.jpg";
var bgimg2 = require("../../images/video-img.jpg");

class Statistics1 extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full overlay-wraper sx-bg-secondry mobile-page-padding  bg-parallax ml-auto"
          data-stellar-background-ratio="0.5"
          style={{ backgroundImage: "url(" + bgimg2 + ")" }}
        >
          <div className="overlay-main bg-black opacity-05" />
          <div className="container">
            <div className="section-content">
              {/* TITLE START */}
              {/* <div className="section-head m-b80" style={{ marginBottom: '80px' }}>
                <div className="sx-separator-outer separator-center">
                  <div
                    className="sx-separator bg-white"
                    // style={{ backgroundImage: "url(" + bgimg2 + ")" }}
                  >
                    <h3 className="bg-white sep-line-one">
                      Vidéo de notre projet
                    </h3>
                  </div>
                </div>
              </div> */}
              {/* TITLE END */}
              <div className="video-section-full-v2">
                <div
                  className="video-section-full bg-no-repeat bg-cover bg-center overlay-wraper m-b30"
                  //   style={{ backgroundImage: "url(" + bgimg2 + ")" }}
                >
                  <div className="round-box animated fadeInUp">
                    <div className="round-inner">
                      <div className="vid-link">
                        <a className="lightbox-image">
                          <div className="icon">
                            <span className="flaticon-play-button-1"></span>
                            <i className="ripple"></i>
                          </div>
                        </a>
                      </div>
                      <div className="title">
                        <h2 className="text-center">Discover our projects</h2>
                      </div>
                      {/* <div className="more-link">
                        <a href="/about">Read More</a>
                      </div> */}
                    </div>
                  </div>
                  <div className="video-section">
                    {/* <div className="sx-separator-outer separator-center">
                      <div className="sx-separator bg-white">
                        <h3 className="sep-line-one">Vidéo de notre projet</h3>
                      </div>
                    </div> */}
                    <div className="video-section-content">
                      <NavLink
                        to={"#"}
                        className="play-now"
                        data-toggle="modal"
                        data-target="#myModal"
                      >
                        <i className="icon fa fa-play" />
                        <span className="ripple" />
                      </NavLink>

                      {/* <div className="video-section-bottom">
                        <h3 className="sx-title text-white">
                          Vidéo de notre projet
                        </h3>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" id="myModal" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <ReactPlayer
                  controls={true}
                  url={require("../../videos/vallee-1er.mp4")}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Statistics1;
